<template>
  <div>
    <div class="p-2.5 bg-zt-light-full border-t border-zt-light text-xs font-normal uppercase">
      {{ title}}
    </div>
    <FootballStatsFilter
        v-if="options.length > 0"
        analytic-type="compare-results"
        class="pt-2.5 bg-[#242e3d] border-zt-light border-t bg-zt-light/35 border-b"
        :is-league-results="true"
        :options="options"
        @filtering-changed="(value) => selectedFilters = value"
    />
    <div class="flex bg-zt-light/35">
      <div class="flex flex-col">
        <div class="py-[15px] pl-2.5 pr-[14px]">
          <img class="w-5 h-5 min-w-5 min-h-5 object-contain aspect-square"
               :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamAQueryName}.png`"
               @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
               :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"/>
        </div>
        <div class="py-[15px] pl-2.5 pr-[14px] border-t border-zt-light">
          <img class="w-5 h-5 min-w-5 min-h-5 object-contain aspect-square"
               :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamBQueryName}.png`"
               @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
               :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"/>
        </div>
      </div>
        <div ref="icons-container" class="flex flex-col overflow-x-auto">
          <Transition name="fade" mode="out-in">
            <div :key="homeAway" ref="icons-teama" class="flex gap-x-[6px] h-[calc(50%+1px)] items-center">
              <FootballStatsListItemIcon
                  v-for="(match, index) of matches[0]" :key="match.match_id"
                  :displaying-stat="displayingStat"
                  :team-id="teamAId"
                  :index="index"
                  :current-filters="completeFilters"
                  :ish2h="true"
                  :filtering-result="calculateFilterResult(match, +match.localteam_id === +teamAId, teamAId)"
                  :match="match"/>
            </div>
          </Transition>
          <hr class="border-t border-zt-light" :style="{ width: borderWidth + 'px' }"/>
          <Transition name="fade" mode="out-in">
            <div ref="icons-teamb" :key="homeAway"
                 class="flex gap-x-[6px] h-[calc(50%+1px)] items-center">
              <FootballStatsListItemIcon
                  v-for="(match, index) of matches[1]" :key="match.match_id"
                  :displaying-stat="displayingStat"
                  :team-id="teamBId"
                  :index="index"
                  :current-filters="completeFilters"
                  :ish2h="true"
                  :filtering-result="calculateFilterResult(match, +match.localteam_id === +teamBId, teamBId)"
                  :match="match"/>
            </div>
          </Transition>
        </div>
    </div>
  </div>
</template>

<script>
import FootballStatsFilter from "../../FootballStatsFilter.vue";
import FootballStatsListItemIcon from "../../blocks/FootballStatsListItemIcon.vue"

export default {
  name: "NarrowStatMatchList",
  components: {FootballStatsListItemIcon, FootballStatsFilter},
  props: {
    filters: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    matches: {
      type: Array,
      required: true
    },
    teamAId: {
      type: [String, Number],
      required: true
    },
    teamBId: {
      type: [String, Number],
      required: true
    },
    teamAQueryName: {
      type: String,
      required: true
    },
    teamBQueryName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true,
    },
    homeAway: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      selectedFilters: [],
      borderWidth: 0,
    }
  },
  mounted() {
    this.calculateBorderWidth();
  },
  methods: {
    calculateBorderWidth() {
      setTimeout(() => {
        this.borderWidth = Math.max(this.$refs["icons-teama"].scrollWidth, this.$refs["icons-teamb"].scrollWidth) + 10;
        if (window.size.desktop === true) {
          this.borderWidth = Math.max(this.borderWidth, 577);
        }
      }, 100);
    },
    calculateFilterResult(match, isLocal, teamId, filters = this.completeFilters) {
      if (filters[0] === '1x2') {
        if (match.localteam_goals === match.visitorteam_goals) {
          if (match.localteam_penalty_shootout > 0 || match.visitorteam_penalty_shootout > 0) {
            if (isLocal) {
              return match.localteam_penalty_shootout > match.visitorteam_penalty_shootout ? 'W' : 'P';
            } else {
              return match.visitorteam_penalty_shootout > match.localteam_penalty_shootout ? 'W' : 'P';
            }
          }
          return 'R';
        }
        if (this.homeAway === 'home/away') {
          if (isLocal) {
            return match.localteam_goals > match.visitorteam_goals ? 'W' : 'P';
          } else {
            return match.visitorteam_goals > match.localteam_goals ? 'W' : 'P';
          }
        } else {
          if (+match.localteam_id === teamId) {
            return match.localteam_goals > match.visitorteam_goals ? 'W' : 'P';
          } else {
            return match.visitorteam_goals > match.localteam_goals ? 'W' : 'P';
          }
        }
      }
      if (filters[0] === 'overunder') {
        const value = filters[1];
        const matchGoals = +match.localteam_goals + +match.visitorteam_goals - +match.localteam_et_goals - +match.visitorteam_et_goals;
        return matchGoals > value ? 'W' : 'P';
      }
      if (filters[0] === 'btts') {
        return +match.localteam_goals - +match.localteam_et_goals > 0 && +match.visitorteam_goals - +match.visitorteam_et_goals > 0 ? 'W' : 'P';
      }
      if (filters[0] === 'corners' && filters[1] === 'overunder') {
        const value = filters[2];
        const matchCorners = +match.localteam_corners + +match.visitorteam_corners;
        return matchCorners > value ? 'W' : 'P';
      }
      if (filters[0] === 'corners' && filters[1] === 'result') {
        if (+match.localteam_corners === +match.visitorteam_corners) {
          return 'R';
        }
        if (+match.localteam_id === teamId) {
          return +match.localteam_corners > +match.visitorteam_corners ? 'W' : 'P';
        } else {
          return +match.visitorteam_corners > +match.localteam_corners ? 'W' : 'P';
        }
      }
      if (filters[0] === 'cards' && filters[2] === 'overunder') {
        const value = filters[3];
        const matchCards = filters[1] === 'yellowcards' ? +match.localteam_yellowcards + +match.visitorteam_yellowcards :
            +match.localteam_red_cards + +match.visitorteam_red_cards;
        return matchCards > value ? 'W' : 'P';
      }
      if (filters[0] === 'cards' && filters[2] === 'result' && filters[1] === 'yellowcards') {
        if (+match.localteam_yellowcards === +match.visitorteam_yellowcards) {
          return 'R';
        }
        if (+match.localteam_id === teamId) {
          return match.localteam_yellowcards > match.visitorteam_yellowcards ? 'W' : 'P';
        } else {
          return match.visitorteam_yellowcards > match.localteam_yellowcards ? 'W' : 'P';
        }
      }
      if (filters[0] === 'cards' && filters[2] === 'result' && filters[1] === 'red') {
        if (+match.localteam_red_cards === +match.visitorteam_red_cards) {
          return 'R';
        }
        if (+match.localteam_id === teamId) {
          return match.localteam_red_cards > match.visitorteam_red_cards ? 'W' : 'P';
        } else {
          return match.visitorteam_red_cards > match.localteam_red_cards ? 'W' : 'P';
        }
      }
      if (filters[0] === 'halfs') {
        if (filters[1] === 'firsthalf') {
          if (match.localteam_ht_goals === match.visitorteam_ht_goals) {
            return 'R';
          }
          if (+match.localteam_id === teamId) {
            return match.localteam_ht_goals > match.visitorteam_ht_goals ? 'W' : 'P';
          } else {
            return match.visitorteam_ht_goals > match.localteam_ht_goals ? 'W' : 'P';
          }
        } else {
          if ((+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals) === (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals)) {
            return 'R';
          }
          if (+match.localteam_id === teamId) {
            return (+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals) > (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals) ? 'W' : 'P';
          } else {
            return (+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals) < (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals) ? 'W' : 'P';
          }
        }
      }
      if (filters[0] === 'penalty') {
        if (filters[1] === 'for') {
          if (+match.localteam_id === +teamId) {
            return +match.localteam_penalties > 0 ? 'W' : 'P';
          } else {
            return +match.visitorteam_penalties > 0 ? 'W' : 'P';
          }
        } else if (filters[1] === 'against') {
          if (+match.localteam_id === +teamId) {
            return +match.visitorteam_penalties > 0 ? 'W' : 'P';
          } else {
            return +match.localteam_penalties > 0 ? 'W' : 'P';
          }
        }
        return +match.localteam_penalties > 0 || +match.visitorteam_penalties > 0 ? 'W' : 'P';
      }
    }
  },
  computed: {
    completeFilters() {
      return [...this.filters, ...this.selectedFilters];
    },
    displayingStat() {
      if (this.completeFilters[0] === 'corners') {
        return 'corners';
      }
      if (this.completeFilters[0] === 'cards') {
        return 'cards';
      }
      if (this.completeFilters[0] === 'halfs') {
        return this.completeFilters[1] === 'firsthalf' ? 'firsthalf' : 'secondhalf'
      }
      if (this.completeFilters[0] === 'penalty') {
        return 'penalty';
      }
      if (this.completeFilters[0] === 'btts' || this.completeFilters[0] === 'overunder') {
        return 'ft_goals'
      }
      return 'goals';
    },
  }
}

</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;

}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

::-webkit-scrollbar {
  @apply w-[5px] h-[2px];
}
::-webkit-scrollbar-track {
  @apply bg-transparent;
}
::-webkit-scrollbar-thumb {
  @apply bg-white/30 border-[5px] border-zt-more rounded-[6.25rem] bg-clip-content
}
</style>